export default {
  data () {
    return {
      reg: {
        number: '',
        password: '',
        repassword: ''
      },
      err: {
        number: '',
        password: '',
        repassword: ''
      }
    }
  },
  computed: {
    passIsValid: function () {
      return !(this.reg.password.length < 7)
    },
    repasswordIsValid: function () {
      return this.reg.repassword === this.reg.password
    }
  },
  methods: {
    numericOnly ($event) {
      // make javascript keycode accept only 0-9
      if ($event.keyCode < 48 || $event.keyCode > 57) {
        $event.preventDefault()
      }
    },
    checkboxValidation ($event) {
      // console.log($event)
    }
  }
}
